<div
  [class]="
    'relative grid gap-(--visitcard-gap) px-(--visitcard-padding-x) py-(--visitcard-padding-y) rounded-(--visitcard-border-radius) ' +
    (config().shadow ? 'shadow-(--visitcard-shadow) ' : '') +
    (config().border
      ? 'border-(length:--visitcard-border-width,var(--border-width-xs)) border-(--visitcard-border-color)'
      : '')
  "
  [style.background]="containerBackground()"
>
  @if (config().canDismiss) {
    <div class="absolute top-0 right-0 pt-(--visitcard-padding-y) pr-(--visitcard-padding-x)">
      <app-dynamic
        componentName="IconButton"
        [props]="{ config: { icon: 'x', size: 'sm', ariaLabel: 'Close' } }"
        (action)="onClose()"
      />
    </div>
  }
  @if (chipConfig()) {
    <app-dynamic
      componentName="Chip"
      [props]="{ config: chipConfig() }"
    />
  }

  <div class="flex gap-2 items-center w-full">
    <div class="flex flex-col gap-1 flex-1">
      @for (title of normalizedTitles(); track $index) {
        <app-dynamic
          componentName="DynamicText"
          [props]="{
            config: {
              text: title.text,
              size: 'xl',
              fontFamily: 'var(--visitcard-title-font-family, var(--font-sans))',
              fontWeight: 'semibold',
              color: title.color,
              cssVarPrefix: 'visitcard-title',
            },
          }"
        />
      }
    </div>
    @if (config().infoIcon) {
      <app-dynamic
        componentName="SvgIcon"
        [props]="{ name: config().infoIcon, size: '16', color: defaultTitleColor() }"
        class="shrink-0 self-start"
      />
    }
  </div>

  @if (config().subtext) {
    <div class="w-full">
      <app-dynamic
        componentName="DynamicText"
        [props]="{
          config: {
            text: config().subtext!,
            size: 'sm',
            fontWeight: 'normal',
            color: isHighlighted() ? 'var(--visitcard-highlighted-subtext)' : 'var(--visitcard-idle-subtext)',
            whiteSpace: config().whiteSpace,
          },
        }"
      />
    </div>
  }
  @if (config().buttons?.length) {
    <div class="flex flex-col gap-3 w-full">
      @for (buttonConfig of config().buttons; track $index) {
        <app-dynamic
          componentName="Button"
          [props]="{ config: buttonConfig, disabled: disabled() }"
          (action)="onButtonClick($event)"
        />
      }
    </div>
  }
</div>
